import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../../services/api';
import { useLanguage } from '../../contexts/LanguageContext';
import './MyBookings.css';

const MyBookings = () => {
  const { t, language } = useLanguage();
  const [bookings, setBookings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await apiService.getUserBookings();
        if (response.success) {
          setBookings(response.data);
        } else {
          throw new Error(response.message || t('dashboard.bookings.errors.fetchFailed'));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBookings();
  }, []);

  const dateLocale = language === 'hi' ? 'hi-IN' : language === 'or' ? 'or-IN' : 'en-IN';
  const getTranslatedStatus = (status) => {
    const normalized = String(status || '').toLowerCase();
    const translated = t(`dashboard.common.status.${normalized}`, {}, '');
    if (translated) return translated;
    return normalized ? normalized.charAt(0).toUpperCase() + normalized.slice(1) : status;
  };

  if (isLoading) return <div className="loading-spinner">{t('dashboard.bookings.loading')}</div>;

  if (error) {
    return <div className="error-message">{t('dashboard.common.errorPrefix')}: {error}</div>;
  }

  return (
    <div className="my-bookings-container">
      <h2>{t('dashboard.sidebar.myPoojaBookings')}</h2>
      {bookings.length === 0 ? (
        <div className="no-bookings">
          <p>{t('dashboard.bookings.emptyMessage')}</p>
          <Link to="/online-pooja" className="btn btn-primary">{t('dashboard.bookings.bookNow')}</Link>
        </div>
      ) : (
        <div className="bookings-list">
          {bookings.map((booking) => (
            <div key={booking.bookingId} className="booking-card">
              <div className="card-header">
                <h3>{booking.poojaType}</h3>
                <span className={`status-badge status-${booking.paymentStatus}`}>
                  {getTranslatedStatus(booking.paymentStatus)}
                </span>
              </div>
              <div className="card-body">
                <p><strong>{t('dashboard.bookings.fields.bookingId')}:</strong> {booking.bookingId}</p>
                <p><strong>{t('dashboard.bookings.fields.temple')}:</strong> {booking.temple}</p>
                <p><strong>{t('dashboard.bookings.fields.date')}:</strong> {booking.poojaDate}</p>
                <p><strong>{t('dashboard.bookings.fields.time')}:</strong> {booking.poojaTime}</p>
              </div>
              <div className="card-footer">
                <p>{t('dashboard.bookings.fields.bookedOn')}: {new Date(booking.createdAt).toLocaleDateString(dateLocale)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyBookings;
